import { render } from "./DeleteProcessModal.vue?vue&type=template&id=847cfcb4&scoped=true&ts=true"
import script from "./DeleteProcessModal.vue?vue&type=script&lang=ts"
export * from "./DeleteProcessModal.vue?vue&type=script&lang=ts"

import "./DeleteProcessModal.vue?vue&type=style&index=0&id=847cfcb4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-847cfcb4"]])

export default __exports__